<template>
    <b-modal
        id="depunereModal"
        v-model="depunereModal"
        size="xl"
        ok-variant="success"
        ok-title="Confirmă"
        cancel-variant="danger"
        cancel-title="Anulează"
        header-bg-variant="light"
        body-bg-variant="light"
        hide-footer
        hide-header
        centered
        @hide="$emit('hideDepPopup');onHide($event)"
    >

        <div class="modal-wrapper" style="min-height: 350px;">
            <div class="popup-title">
                <svg viewBox="0 0 24 24" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>
                <span>{{ popupTitle }}</span>
                <button class="cls-btn" @click="$emit('hideDepPopup')"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                </svg></button>
            </div>
            <div class="popup-content">
                <b-form-group :label="labelName">
                    <b-form-input :type="inputType"></b-form-input>
                </b-form-group>
                <b-form-group :label="labelName2">
                    <b-form-select v-model="selected" :options="options"></b-form-select>
                </b-form-group>
                <b-form-group :label="labelName3">
                    <b-form-select v-model="selected2" :options="options2"></b-form-select>
                </b-form-group>
            </div>
            <div class="popup-btn-wrapper">
                <b-button class="add-popup">Adauga</b-button>
            </div>
        </div>
    </b-modal>
</template>

<script>
    import {BModal, BForm, BFormGroup, BFormInput, BButton, BIconTrash, BFormTextarea, BFormFile, BIconUpload, BFormSelect} from 'bootstrap-vue';
    import vSelect from 'vue-select'
    export default {
        components: {
            BModal,
            BForm,
            BFormGroup,
            BFormInput,
            BFormSelect,
            BButton,
            BIconTrash,
            BFormTextarea,
            BFormFile,
            BIconUpload,
            vSelect
        },
        props: {
            depunereModal: {
                type: Boolean,
                default: false
            },
            popupTitle:{
                type:String,
                default:""
            },
            inputType:{
                type:String,
                default:""
            },
            labelName:{
                type:String,
                default:""
            },
            labelName2:{
                type:String,
                default:""
            },
            labelName3:{
                type:String,
                default:""
            }
        },
        data() {
            return {
                selected: null,
                options: [
                    {
                        value: 'a',
                        text: '2021 - Microgranturi acordate din fonduri externe nerambursabile'
                    }
                ],
                selected2: null,
                options2:[
                    {
                        value:'b',
                        text: 'PFA, II, IF, ONG cu activitate economică în unul dintre domeniile de activitate prevăzute în anexa nr. 1'
                    },
                    {
                        value: 'c',
                        text: 'Profesii liberale cu activitate economică în unul dintre domeniile de activitate prevăzute în anexa nr. 1'
                    }
                ]
            }
        },
        mounted() {
            
        },
        methods: {
            onHide(evt) {
                if(evt.trigger === "backdrop"){
                    evt.preventDefault();
                    this.$emit('hideDepPopup')
                }
            },
        },
    };
</script>
<style>
#depunereModal .modal-body {
    padding: 0;
    border-radius: 15px;
    background-color: transparent!important;
}
#depunereModal .modal-content {
    max-width: 960px;
    margin: 0 auto;
    border-radius: 15px;
    background-color:transparent;
}
#depunereModal .col-form-label {
    font-size: 13px!important;
}
#depunereModal .form-group:nth-of-type(2),
#depunereModal .form-group:last-of-type {
    margin-bottom: 0;
}
</style>
<style scoped>

.modal-body{
    display: flex;
    flex-direction: column;
    align-items: center;
}
.modal-body .popup-title {
    background-color: #3482e7;
    color:white;
    padding: calc(1rem + 5px);
    display: flex;
    align-items: center;
    border-top-left-radius: 15px;   
    border-top-right-radius: 15px;
}
.modal-body .popup-title span {
    font-size: 1.25rem;
    font-weight: 500;
}
.modal-body .popup-title svg {
    width: 24px;
    fill:#ffffff;
    margin-right: 5px;
}
.modal-body .popup-content {
    padding: .5rem 1.5rem;
    background-color:#f8f9fa;
}
.modal-body .popup-btn-wrapper {
    text-align: center;
    padding-bottom: 15px;
    background-color:#f8f9fa;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
}
.modal-body .popup-btn-wrapper .add-btn {
    border-radius: 50px;
    font-size: 14px;
}
.modal-body .form-control,
.modal-body .custom-select {
    min-height:46px;
}

.modal-body >>> .modal-header {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    position: relative;
}
.modal-body p{
    color: #fff;
    text-align: center;
    margin-top: 15px;
}
.cls-btn{
    position: absolute;
    right: 1rem;
    line-height: 40px;
    font-weight: 600;
    color: #ffffff;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    cursor: pointer;
    background-color: transparent;
    border:none;
    outline: none;
}
.cls-btn:hover{
    background-color: rgba(255, 255, 255, .2);
}
.add-popup {
    border-radius:50px;
    font-size: .775rem;
    padding: 10px 21px;
    background-color: #d6dce4;
    border-color:#d6dce4;
    color:#94a3b8;
}
.button-confirm{
    color: #fff;
    font-size: 14px;
    border: 1px solid #fff;
    border-radius: 4px;
    text-align: center;
    padding: 5px 10px;
    width: 50%;
}
.button-confirm:hover{
    background: #fff;
    color: #000;
    cursor: pointer;
}

</style>